// A member literally named "by-id" still has ordinary tabs under that name.
export const isPublicProfileSummaryPath = (path) =>
  /^\/users\/[^/]+\/?$/.test(path) || /^\/users\/by-id\/[1-9]\d*\/?$/.test(path);

export const isPublicProfileRecordsPath = (path) =>
  /^\/users\/[^/]+\/(ratings|reviews|lists|saved|comments)\/?$/.test(path);

export const isPublicProfileTastePath = (path) => /^\/users\/[^/]+\/taste\/?$/.test(path);

// MY's own content uses the same screen for regular members and administrators.
// Editors/settings/guest views have independent navigation and must remain excluded.
export const isMyProfileScrollPath = (path) =>
  /^\/mypage(?:\/(ratings|reviews|lists|saved|comments|taste|badges))?\/?$/.test(path);

export const isPublicProfileBadgesPath = (path) => /^\/users\/[^/]+\/badges\/?$/.test(path);

// Settings is also available to guests; its landing owns return position independently.
export const isSettingsScrollPath = (path) => /^\/mypage\/settings\/?$/.test(path);
